import { render, staticRenderFns } from "./OverviewReportLiveSupport.vue?vue&type=template&id=0bcad461"
import script from "./OverviewReportLiveSupport.vue?vue&type=script&lang=js"
export * from "./OverviewReportLiveSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports